import { AuthService } from './../../services/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ITerms } from './interfaces/ITerms';
import { decode } from "js-base64";

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  public terms: string = '';
  public showTerms: boolean = false;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  public async getTerms() {
    const token = this.authService.getToken();
    const header = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'x-ibm-client-id': environment.service.termService.clientId,
      'x-applicantion': environment.keycloak.clientId,
    });

    try {
      const response = await this.http
        .get<ITerms>(
          `${environment.service.termService.endpoint_url}/TermsConditions`,
          { headers: header }
        )
        .toPromise();

      if (response.httpCode === 200) {
        this.terms = decode(response.base64);
      }
    } catch (error) {
      console.warn(error);
    }
  }
}
